// @ts-nocheck
import React, { Fragment, memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-bootstrap';
import ToastSwal from '../../../../../../components/Shared/Alert/ToastSwal';
import { DndContext } from '@dnd-kit/core';
import { SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { arrayMove } from '@dnd-kit/sortable';
import Select from 'react-select';

const Step3 = ({ fields, setCheckValidationStep3, setDataStep3, DataById }) => {
  const { t, i18n } = useTranslation();

  const [tableFields, setTableFields] = useState(DataById);
  const [sqlName, setsqlName] = useState('');
  const [aliasName, setAliasName] = useState('');
  const [inputType, setInputType] = useState('');
  const [label, setLabel] = useState('');

  useEffect(() => {
    setTableFields(prevState =>
      prevState?.map(item => ({
        ...item,
        Label: fields?.find(f => f.name === item.sqlName)?.label
      }))
    );
  }, [fields, DataById]);

  const handleAddToTable = e => {
    e.preventDefault();
    if (sqlName && aliasName) {
      // Check if the already exists in the table array
      const Exists = tableFields?.some(item => item.sqlName === sqlName);
      if (Exists) {
        ToastSwal({
          icon: 'info',
          title: 'تمت إضافته مسبقاً',
          position: 'top'
        });
        return;
      }

      const newData = {
        id: null,
        name: aliasName,
        name2: aliasName,
        sqlName: sqlName,
        Label: label,
        sequenceNum: tableFields?.length + 1,
        inputType: inputType
      };
      setTableFields([...tableFields, newData]);
      setsqlName('');
      setAliasName('');
      setLabel('');
    }
  };

  const handleDeleteRow = sqlName => {
    debugger;
    const updatedFields = tableFields.filter(row => row.sqlName !== sqlName);
    // const reorderedFields = updatedFields.map((item, index) => ({
    //   ...item,
    //   sequenceNum: index + 1, // إعادة الترتيب يبدأ من 1
    // }));
    setTableFields(updatedFields);
  };

  // console.log(sqlName);
  // console.log(inputType);
  // console.log(label);

  //_______________________ Stard Validation Table  ______________________________________
  useEffect(() => {
    setCheckValidationStep3(tableFields?.length > 0);
    setDataStep3(tableFields);
  }, [tableFields]);
  //_______________________ End Validation Table  ______________________________________

  const handleDragEnd = event => {
    const { active, over } = event;

    if (active?.id !== over?.id) {
      const oldIndex = tableFields.findIndex(row => row.sqlName === active?.id);
      const newIndex = tableFields.findIndex(row => row.sqlName === over?.id);
      // setTableFields((items) => arrayMove(items, oldIndex, newIndex));

      const updatedFields = arrayMove(tableFields, oldIndex, newIndex);

      // تحديث Sequance لكل صف بناءً على ترتيبه الجديد
      const reorderedFields = updatedFields.map((item, index) => ({
        ...item,
        sequenceNum: index + 1 // الترتيب يبدأ من 1
      }));

      setTableFields(reorderedFields);
    }
  };

  const SortableRow = ({ id, children }) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });
    const style = {
      transform: `translateY(${transform ? transform.y : 0}px)`,
      transition,
      cursor: 'move'
    };
    return (
      <tr ref={setNodeRef} style={style} {...listeners} {...attributes}>
        {children}
      </tr>
    );
  };

  return (
    <Fragment>
      <Form onSubmit={handleAddToTable}>
        <div className='row align-items-end'>
          <div className='col-xl-5'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('Column')}</label>

              <Select
                required
                classNamePrefix='react-select'
                isSearchable 
                // isClearable
                options={
                  fields &&
                  fields?.map(item => ({
                    value: item.name,
                    label: item.label,
                    inputType: item.inputType
                  }))
                }
                value={
                  fields
                    ?.map(item => ({
                      value: item.name,
                      label: item.label,
                      inputType: item.inputType
                    }))
                    .find(opt => opt.value === sqlName) || null
                }
                onChange={option => {
                  setsqlName(option.value);
                  setInputType(option.inputType);
                  setLabel(option.label);
                }}
                placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: base => ({ ...base, zIndex: 9999 })
                }}
              />

              {/* <Form.Select
                className='form-select'
                value={sqlName}
                onChange={e => {
                  setsqlName(e.target.value);
                  setInputType(e.target.selectedOptions[0].dataset.inputType);
                  setLabel(e.target.selectedOptions[0].dataset.label);
                }}
                required
              >
                <option>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                {fields &&
                  fields?.map(item => (
                    <option value={item.name} key={item.name} data-input-type={item.inputType} data-label={item.label}>
                      {i18n.language === 'ar' ? item.label : item.label}
                    </option>
                  ))}
              </Form.Select> */}
            </div>
          </div>
          <div className='col-xl-5'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('Alias_Name')}</label>
              <Form.Control
                className='form-control'
                type='text'
                autoComplete='off'
                value={aliasName}
                onChange={e => setAliasName(e.target.value)}
                required
              />
            </div>
          </div>
          <div className='col-xl-2 text-end  '>
            <div className=' form-group mb-3 d-flex justify-content-end '>
              <button type='submit' className='btn me-1 btn-outline-theme w-100'>
                <i className='fa fa-plus-circle fa-fw me-1'></i>
                {t('Add')}
              </button>
            </div>
          </div>
        </div>
      </Form>

      {tableFields?.length > 0 ? (
        <DndContext onDragEnd={handleDragEnd}>
          <SortableContext items={tableFields.map(row => row.sqlName)} strategy={verticalListSortingStrategy}>
            <table className='table table-hover'>
              <thead className='bg-theme bg-opacity-60'>
                <tr>
                  <th style={{ width: '10%' }}></th>
                  <th style={{ width: '10%' }}>{t('Order')}</th>
                  <th style={{ width: '35%' }}>{t('Column')}</th>
                  <th style={{ width: '35%' }}>{t('Alias_Name')}</th>
                  <th style={{ width: '10%' }} className='text-end'></th>
                </tr>
              </thead>
              <tbody>
                {tableFields
                  ?.slice()
                  ?.sort((a, b) => a.sequenceNum - b.sequenceNum)
                  ?.map((row, index) => (
                    <SortableRow key={row.sqlName} id={row.sqlName}>
                      <td className='align-middle'>
                        <a
                          href='/#'
                          title='مقبض السحب'
                          style={{
                            textDecoration: 'none',
                            cursor: 'grab',
                            pointerEvents: 'none'
                          }}
                        >
                          ⁞⁞
                        </a>
                      </td>
                      <td className='align-middle'>{row?.sequenceNum}</td>
                      <td className='align-middle'>{row?.Label}</td>
                      <td className='align-middle'>{row?.name}</td>
                      <td className='align-middle text-end'>
                        <button
                          type='button'
                          className='btn btn-sm btn-outline-danger me-1'
                          onClick={() => handleDeleteRow(row.sqlName)}
                          onPointerDown={e => e.stopPropagation()} // منع السحب عند النقر
                        >
                          <i className='fas fa-trash-alt fa-lg  '></i>
                        </button>
                      </td>
                    </SortableRow>
                  ))}
              </tbody>
            </table>
          </SortableContext>
        </DndContext>
      ) : (
        <div className='border border-theme text-center bg-inverse bg-opacity-10 rounded-2 p-3 fw-bold'>
          {t('الرجاء اختيار الأعمدة المراد عرضها في التقرير.')}
        </div>
      )}
    </Fragment>
  );
};

export default memo(Step3);
